import Controler from "../common/control";
import React, { useCallback, useEffect, useState } from "react";
import { Formik,Form} from "formik";
import { connect } from "react-redux";
import {getStudyabroadIdp, postStudyabroadIdp} from '../../../store/slices/studyabroad'
import "../../assets/css/idp-medical.css";
import { fetchUser } from "../../../store/slices/user/index";
import Loader from "../common/loader";
import ButtonLoader from "../common/buttonLoader";
import ThankYouStudyabroad from "./thankYou";
import ExitPopup from "./exitPopup";

const randomNum = ()=>{
  const d = new Date();
  const ms = d.getMilliseconds();
  return ms
}
const debounceHandler = (callback, wait) => {
  let timer;
  const debouncedFunc = (...args) => {
    if(timer) clearTimeout(timer)
    timer = setTimeout(()=>{
      callback(...args)
    }, wait)
  }
  return debouncedFunc;
}

const IdpStudyabroadForms = (props) => {
  const [countries, setCountries] = useState(null)
  const [intakeYear, setIntakeYear] = useState(null)
  const [fees, setFees] = useState(null)
  const [primaryStreams, setPrimaryStreams] = useState([])
  const [streams, setStreams] = useState(null)
  const [educationLoan, setEducationLoan] = useState(null)
  const [passport, setPassport] = useState(null)
  const [apptitudeExams, setApptitudeExams] = useState(null)
  const [englishExams, setEnglishExams] = useState(null)
  const [examScore, setExamScore] = useState([])
  const [degree, setDegree] = useState([])
  
  const [isPopup, setIsPopup] = useState(false)
  const [destination, setDestination] = useState(null)
  const [checkEntity,setCheckEntity] = useState('')
  const [isLoading,setIsLoading] = useState(true)
  const [isDisable,setIsDisable] = useState(true)
  const [formikState, setFormikState] = useState({})
  const [isSubmitted,setIsSubmitted] = useState(false)
  const [submitLoader,setSubmitLoader] = useState(false)
  const [formikVal,setFormikVal] = useState({})

  useEffect(() => { 
    props.dispatch(fetchUser())
  }, [])

  useEffect(() => { 
    if(props.user?.data){
      props.dispatch(getStudyabroadIdp({uid: props.user?.data?.id, ms:randomNum()}));
    }
    let desti
    if(!!window.location?.search){
      desti = window.location?.search?.replace("?destination=", "");
    } else {
      desti = 'https://www.careers360.com'
    }
    setDestination(desti);
  }, [props.user?.data]);

  useEffect(()=>{
    if(props.isExitIdp){
      setIsPopup(props.isExitIdp)
    }
    if(isPopup === false) props.setIsExitIdp(false)
  },[isPopup,props.isExitIdp])

  const handleIdpData = (arr,type, stateName)=>{
    let checkedValue = []
    let item
    stateName(arr)
    
    for(item of arr?.value || arr){ 
      if(item.selected) {
        if(['country', 'study_abroad_exams_apptitude','study_abroad_exams_english','study_abroad_streams','study_abroad_degrees','intake_year'].includes(type)){
          checkedValue.push(`${item.id}`)
        } else {
          checkedValue = `${item.id}`
        }
      }
    }
    setFormikState(prev => ({
      ...prev,
      [type]: checkedValue
    }))
  }

  const getScoreData = (data)=>{
    return {
      id:data.id,
      name:data.short_name||data.name,
      max_score: data?.score_range_value?.max_score ? data?.score_range_value?.max_score : null,
      min_score: data.score_range_value?.min_score != null && data.score_range_value?.min_score === 0 ? 0 : data.score_range_value?.min_score,
      exam_given: data.value?.exam_given ? data.value?.exam_given : 0,
      sa_score: data.value?.sa_score ? data.value?.sa_score : ''
    }
  }

  useEffect(()=>{
    if(!!props.idpData?.idp?.length){
      setCountries(null)
      setIntakeYear(null)
      setApptitudeExams(null)
      setEnglishExams(null)
      setFees(null)
      setStreams(null)
      setEducationLoan(null)
      setPassport(null)
      setDegree(null)
      setPrimaryStreams(null)

      let data
      for(data of props.idpData?.idp){
        setIsLoading(false)
        if(data.entity === "country" && !!data?.value?.length) handleIdpData(data, 'country', setCountries)
        else if(data.entity === "intake_year" && !!data?.value?.length){
          !!data?.value?.length && handleIdpData(data, 'intake_year', setIntakeYear)
        } else if(data.entity === "study_abroad_exams") {
          let tempScoreData = []
          if(!!data?.value?.apptitude_exam?.length){
            handleIdpData(data?.value?.apptitude_exam, 'study_abroad_exams_apptitude', setApptitudeExams)
            let item
            for(item of data?.value?.apptitude_exam){
              if(item.selected) tempScoreData.push(getScoreData(item))
            }
          } 
          if(!!data?.value?.english_exam?.length){
            handleIdpData(data?.value?.english_exam, 'study_abroad_exams_english', setEnglishExams)
            let item
            for(item of data?.value?.english_exam){
              if(item.selected) tempScoreData.push(getScoreData(item))
            }
          }
          setExamScore(tempScoreData)
        }
        else if(data.entity === "study_abroad_degrees" && !!data?.value?.length) handleIdpData(data, 'study_abroad_degrees', setDegree)
        else if(data.entity === "study_abroad_fixed_budget" && !!data?.value?.length) handleIdpData(data, 'study_abroad_fixed_budget', setFees)
        else if(data.entity === "study_abroad_streams" && !!data?.value?.length) handleIdpData(data, 'study_abroad_streams', setStreams)
        else if(data.entity === "study_abroad_primary_stream" && !!data?.value?.length) (setPrimaryStreams(data))
        else if(data.entity === "study_abroad_education_loan" && !!data?.value?.length) handleIdpData(data, 'study_abroad_education_loan', setEducationLoan)
        else if(data.entity === "study_abroad_passport" && !!data?.value?.length) handleIdpData(data, 'study_abroad_passport', setPassport)
      }

      const gotToHomePage = window.location?.origin;
      if (props.idpData?.admission_preference_status == 2){
        !!destination ? window.location.href = destination : gotToHomePage
      }
      if(props.idpData?.idp_form_id == 0){
        !!destination ? window.location.href = destination : gotToHomePage;
      }
      if(props?.idpData?.idp_form_id && ![-2].includes(props?.idpData?.idp_form_id)){
        window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
      }
    }
  },[props.idpData])

  useEffect(()=>{
    if(!!props.idpData?.education_level){
      let educationLavel
      if(props.idpData?.education_level == 1) educationLavel = 'UG'
      else if(props.idpData?.education_level == 2) educationLavel = 'PG'
      else educationLavel = ''
      _browsee('identify', props.user?.data?.id, {'$tags': ["Study Abroad",educationLavel,"Step2","Study Abroad","IDP"]})
    }
  },[props.idpData?.education_level])

  const isValidate = (data)=> {
    let item
    let tempData = {}
    for(let key in data){
      if(key != 'study_abroad_streams'){
        tempData[key] = data[key]
      }
    }
    
    let validateData = Object.values(tempData)
    for(item of validateData) {
      if (!Array.isArray(item)) {
        if(item === '') return true
      }
      if (item.length === 0) return true;
    }
    return false;
  }

  useEffect(()=>{
    setIsDisable(isValidate(formikVal))
    props.getCountryIds(formikVal)
  },[formikVal])

  const handleMultiSelectDefaultCheck = (arr)=>{
    let ar = [];
    let item
    for(item of arr){
      if (item.selected) ar.push(item);
    } 
    return ar;
  };
    
  const scoreHandle = (event)=>{
    let examScoreData = [...examScore];  
    if(event.currentTarget.checked) {
      [...apptitudeExams, ...englishExams]?.find(item => {
        if(item.id == event.currentTarget.value) examScoreData.push(getScoreData(item))
      })
    } else {
      var index = examScoreData.findIndex(obj=> obj.id === +event.currentTarget.value)
      examScoreData.splice(index, 1);
    }
    setExamScore(examScoreData);
    return examScoreData
  }
  
  const examScoreHandle = (e, obj, uid) => {
    let postData = {}
    postData.uid = uid
    postData.entity = e.target.name
    if((+e.target.value < obj?.max_score+1 && +e.target.value >= obj?.min_score) || obj?.max_score == null ){
      postData.exam_id = obj?.id
      postData.score = +e.target.value
      if(+e.target.value >= 0) props.dispatch(postStudyabroadIdp(postData))
    }
  }
  const scoreOnchange = useCallback(debounceHandler(examScoreHandle, 500),[]);

  const scoreInputHandle = (e, type, obj)=>{
    let tempObj = examScore   
    let currObj = obj
    let postData = {}
    postData.uid = props.user?.data?.id
    postData.entity = e.target.name
    if(type === 'exam_given'){
      let action = e.target.checked ? 1 : 0
      postData.exam_id = e.target.value
      postData.exam_given = action
      props.dispatch(postStudyabroadIdp(postData))
      currObj.exam_given = action
      currObj.sa_score = ''
      currObj.is_val = false
      let newData = tempObj.map(obj => [currObj]?.find(item => item.id == obj.id) || obj);
      setExamScore(newData)
    } else if(type === 'score_given'){
      currObj.sa_score = e.target.value
      currObj.is_val = !!e.target.value ? true : false
      let newData = tempObj.map(obj => [currObj]?.find(item => item.id == obj.id) || obj);
      setExamScore(newData)
    }
  }

  useEffect(() => { 
    if(props.idpPostData){
      if(['country','submit'].includes(checkEntity)){
        props.dispatch(getStudyabroadIdp({uid: props.user?.data?.id, ms:randomNum()}));
      }
    }
  }, [props.idpPostData]);

  const gotToHomePage = window.location?.origin;
  useEffect(() => {
    if (props?.isUser?.user_error == "User Not Authenticated" && !!destination)
      window.location.href = destination;
    else if (
      props?.isUser?.user_error == "User Not Authenticated" &&
      !destination
    )
      window.location.href = gotToHomePage;
    else if (!!props?.isUser?.user && !destination)
      window.location.href = gotToHomePage;
  }, [props?.isUser]);
  
  const onSubmit = values => {
    let postData = {}
    postData.uid = props.user?.data?.id
    postData.admission_preference_status = 2
    postData.entity = 'submit'
    
    setCheckEntity('submit')
    props.dispatch(postStudyabroadIdp(postData))
    setSubmitLoader(true) 
    setTimeout(()=>{
      setIsSubmitted(true)
    },600)
  }
//countries?.value?.length
  const validate = (values) =>{
    let error = {}
    if(!!countries?.value?.length && !values?.country?.length) error.country = 'This Field is required'
    if(!!intakeYear?.value?.length && !values?.intake_year?.length) error.intake_year = 'This Field is required'
    if(!!fees?.value?.length && !values?.study_abroad_fixed_budget) error.study_abroad_fixed_budget = 'This Field is required'
    if(!!streams?.value?.length && !values?.study_abroad_streams?.length) error.study_abroad_streams = 'This Field is required'

    if(!!educationLoan?.value?.length && !values?.study_abroad_education_loan) error.study_abroad_education_loan = 'This Field is required'
    if(!!passport?.value?.length && !values?.study_abroad_passport?.length) error.study_abroad_passport = 'This Field is required'
    if(!!englishExams?.length && !values?.study_abroad_exams_english?.length) error.study_abroad_exams_english = 'This Field is required'
    if(!!apptitudeExams?.length && !values?.study_abroad_exams_apptitude?.length) error.study_abroad_exams_apptitude = 'This Field is required'
    if(!!degree?.value?.length && !values?.study_abroad_degrees?.length) error.study_abroad_degrees = 'This Field is required'
    
    return error
  }

  return (<>
    {isLoading && <Loader/>}
    
    {isSubmitted && <ThankYouStudyabroad destinationUrl={destination}/>}

    {isPopup && <ExitPopup destinationUrl={destination} setIsPopup={setIsPopup}/>}

    <Formik initialValues={formikState}
      enableReinitialize={true}
      onSubmit={onSubmit}
      validateOnMount = {true}
      validate={validate}  
    >
      {({values, setFieldValue, isValid}) => {
        setTimeout(()=>{
          setFormikVal(values)
        },0)
        const handleChange = (e)=>{
          setCheckEntity(e.target.name)
          let action = e.target.checked ? 1 : 0
          let postData = {}
          postData.uid = props.user?.data?.id
          postData.entity = e.target.name
          if(e.target.name === 'country'){
            postData.country = +e.target.value
            postData.action = action
            props.dispatch(postStudyabroadIdp(postData))
            // setIsLoading(true)
          } else if(['study_abroad_exams_apptitude','study_abroad_exams_english'].includes(e.target.name)){
            postData.selected_exams = +e.target.value
            postData.entity = 'study_abroad_exams'
            postData.action = action
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'study_abroad_fixed_budget'){
            postData.budget = +e.target.value
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'study_abroad_streams'){
            postData.streams = +e.target.value
            postData.action = action
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'study_abroad_education_loan'){
            postData.loan_interested = +e.target.value
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'study_abroad_passport'){
            postData.passport = +e.target.value
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'study_abroad_degrees'){
            postData.degree_id = +e.target.value
            postData.action = action
            props.dispatch(postStudyabroadIdp(postData))
          } else if(e.target.name === 'intake_year'){
            var obj = intakeYear?.value.find(obj=> obj.id == e.currentTarget.value)
            postData.country_id = formikVal?.country
            postData.session = obj?.value
            postData.year = obj?.target_year
            postData.action = action
            props.dispatch(postStudyabroadIdp(postData))
          }
        }

        const handleMultiSelect = (obj, actionMeta) => {
          let isCheck = actionMeta.action === 'select-option' ? true : false
          let getID = actionMeta.action === 'select-option' ? actionMeta.option.id : actionMeta.removedValue.id
          let postData = {}
          postData.uid = props.user?.data?.id
          postData.entity = actionMeta.name
          if(['country'].includes(actionMeta.name)){
            // setIsLoading(true)
          }
          setCheckEntity(actionMeta.name)
          if(actionMeta.name === 'country'){
            postData.country = getID
            postData.action = isCheck
            props.dispatch(postStudyabroadIdp(postData))
          } else if(actionMeta.name === 'study_abroad_degrees'){
            postData.degree_id = getID
            postData.action = isCheck
            props.dispatch(postStudyabroadIdp(postData))
          }

          let objID = actionMeta?.action === 'select-option' ? actionMeta?.option?.id : actionMeta?.removedValue?.id
          let tempArr = [...values[actionMeta.name]]
          let oldIDs = []
          if(isCheck){
            oldIDs = [...values[actionMeta.name],`${objID}`]
          } else {
            let index = values[actionMeta.name].indexOf(`${actionMeta.removedValue.id}`);
            tempArr?.splice(index,1);
            oldIDs = tempArr
          }
          setFieldValue(actionMeta.name, oldIDs);
        }

        return (
          <Form>
            { !!countries?.value?.length && 
              <div className="idp_medical_card">
                <Controler control="checkbox" handleChange={handleChange} isMandatory={true} formikValues={formikVal['country']} options={countries?.value?.slice(0,10)} name="country" questionName="What countries are you targeting for admission?" />

                {countries?.value?.length >= 11 &&
                  <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={countries?.value?.slice(10)} name="country" questionName="" />
                }
                <div className="idp_info_strip">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    Choose your dream university and pursue the right course.
                </div>
              </div>
            }

            { !!intakeYear?.value?.length && 
              <div className="idp_medical_card">
                <Controler control="checkbox" handleChange={handleChange} formikValues={formikVal['intake_year']} isMandatory={true} options={intakeYear?.value} name="intake_year" questionName="When do you plan to study?" />

                <div className="idp_info_strip">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    Colleges & Universities abroad have various intakes in an academic year. We will guide you on the most suitable intake you can target.
                </div>
              </div>
            }

            {!!fees?.value?.length && 
              <div className="idp_medical_card one_line_input">
                <Controler control="radio" handleChange={handleChange} isMandatory={true} options={fees?.value} name="study_abroad_fixed_budget" questionName="How much are you planning to spend on your education?" />

                <div className="idp_info_strip">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    With this information we will guide you with a list of colleges/courses you can target that fit your budget.
                </div>
              </div>
            }

            { !!streams?.value?.length && 
              <div className="idp_medical_card">
                <h2 className="card_medicine_heading">Your primary field of study.</h2>
                {!!primaryStreams?.value && 
                  <div className="idp_input_group">
                    <div className="defaultstream">{primaryStreams?.value}</div>
                  </div>
                }
                
                <p className="sub_question_heading">Any other area of interest ?</p>
                <Controler control="checkbox" handleChange={handleChange} formikValues={formikVal['study_abroad_streams']} isMandatory={true} options={streams?.value} name="study_abroad_streams" questionName="" />

                <div className="idp_info_strip">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    With this information we will guide you through the colleges suitable in your interested field of study.
                </div>
              </div>
            }

            {!!educationLoan?.value?.length && 
              <div className="idp_medical_card">
                <Controler control="radio" handleChange={handleChange} isMandatory={true} options={educationLoan?.value} name="study_abroad_education_loan" questionName="Are you looking for an education loan?" />

                {!!passport?.value?.length &&<>
                  <p className="sub_question_heading">Do you have a passport?</p>
                  <Controler control="radio"intake_year handleChange={handleChange} isMandatory={true} options={passport?.value} name="study_abroad_passport" questionName="" />
                </>}
              </div>
            }

            { (!!apptitudeExams?.length || !!englishExams?.length) && 
              <div className="idp_medical_card">
                <h2 className="card_medicine_heading">What are the exams you have given or plan to give?<span>*</span></h2>
                <p className="sub_question_heading">Select from English Language Proficiency Exams</p>
                <Controler control="checkbox" handleChange={(e)=>{handleChange(e), scoreHandle(e)}} isMandatory={true} formikValues={formikVal['study_abroad_exams_english']} options={englishExams} name="study_abroad_exams_english" questionName="" />
                
                <p className="sub_question_heading">Select from Standardized Tests</p>
                <Controler control="checkbox" handleChange={(e)=>{handleChange(e), scoreHandle(e)}} formikValues={formikVal['study_abroad_exams_apptitude']} isMandatory={true} options={apptitudeExams} name="study_abroad_exams_apptitude" questionName="" />
                
                {!!examScore.length &&
                  <div className="table_exam">
                    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                      <thead>
                        <tr>
                          <td>Exam Name</td>
                          <td>Exam given?</td>
                        <td></td>
                        </tr>
                      </thead>	

                      <tbody>
                        {examScore?.map((item, ind)=>(
                          <tr key={ind}>
                            <td width={110}>{item?.short_name || item?.name}</td>
                            <td><input type="checkbox" value={item?.id} name="study_abroad_exam_given" checked={item?.exam_given == 1} onChange={(e)=>scoreInputHandle(e,'exam_given', item)} className="check_Exam" />Yes</td>
                            {!!item?.max_score &&
                              <td align="right">
                                <input type="number" className="score_input" disabled={item?.exam_given == 0} id={item?.id} name="study_abroad_exam_score" onChange={(e)=>{scoreInputHandle(e,'score_given', item); scoreOnchange(e, item, props.user?.data?.id) }} value={item?.sa_score} placeholder="Enter your score"/>
                                {(+item?.sa_score > item?.max_score || +item?.sa_score < item?.min_score) && item?.exam_given == 1 &&<>
                                  <span className={`score_range_error ${item?.is_val? '':'none'}`}>Score range:  {item?.min_score} - {item?.max_score}</span>
                                </>}
                              </td>
                            }
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                }
                
                <div className="idp_info_strip">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    The choice of exam depends on the country, college, course you seek to pursue.
                </div>
              </div>
            }

            { !!degree?.value?.length && 
              <div className="idp_medical_card">
                <Controler control="checkbox" handleChange={handleChange} isMandatory={true} formikValues={formikVal['study_abroad_degrees']} options={degree?.value?.slice(0,8)} name="study_abroad_degrees" questionName="Which degree are you targeting?" />

                {degree?.value?.length >= 9 &&
                  <Controler control="react_select" handleChange={handleMultiSelect} hendleDefaultCheck={handleMultiSelectDefaultCheck} options={degree?.value?.slice(8)} name="study_abroad_degrees" questionName="" />
                }
              </div>
            }

            <div className="idp_medicine_btn_Submit">
              {submitLoader ? 
                <ButtonLoader/> :
                <input type="submit" className="action-button btn" 
                  disabled={isValid == false}
                  value="Submit your preferences" 
                />
              }
            </div>
          </Form>
        )
      }}  
    </Formik> 
  </>)
    
}
const mapStateToProps = (state) => {
    return {
    user: state.userData?.user,
    isUser: state.userData,
    idpData : state?.idpStydyabroad?.studyabroadIdpSuccess?.data,
    idpPostData : state?.idpStydyabroad?.postStudyabroadIdpSuccess?.data,
  };
};  

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IdpStudyabroadForms);
